import { get, putJson } from '../httpClient';

/**
 * Client for /api/creator/notification-prefs.
 *
 * Self-scoped — the server reads the authenticated user from the SDK
 * session, so there's no userId in the URL. Returned `prefs` always
 * contains every known key (server fills defaults), so the UI can render
 * a toggle for each without first checking what's missing.
 */
export const creatorNotificationsAPI = {
  /** GET /api/creator/notification-prefs */
  getPrefs: () => get('/api/creator/notification-prefs'),

  /** PUT /api/creator/notification-prefs — body: { prefs: { … } } */
  updatePrefs: prefs => putJson('/api/creator/notification-prefs', { prefs }),
};
